<template>
  <div>
    <v-list v-if="items.length > 0" three-line>
      <template v-for="(item) in items">
        <v-list-item
          :key="item.id"
          style="min-height: unset;"
        >
          <v-list-item-content class="">
            <v-list-item-title>
              <span style="font-size: 11px; font-weight: bold;">{{moment.utc(item.created_at).local().format(DATETIME_VIEW)}}</span>&nbsp;
              <span style="font-size: 11px">{{item.causer?item.causer.name:''}}</span>
            </v-list-item-title>
            <div v-html="item.text"></div>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
    <div v-else
         class="text-center my-5"
    >
      <span v-if="isRequest">
        Загрузка....
      </span>
      <span v-else>Событий не найдено</span>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { DATETIME_VIEW } from '@/constants/dates';
import ActivityProxy from '@/proxies/Activity/ActivityProxy';

export default {
  name: 'ActivityList',
  props: {
    method: {
      type: String,
      default: 'orderBaseActivity',
    },
    args: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      moment,
      DATETIME_VIEW,
      isRequest: false,
      interval: null,
      delay: null,
      items: [],
    };
  },
  watch: {
    args: {
      handler() {
        // this.items = [];
        this.delayRequest();
      },
      // deep: true,
    },
  },
  mounted() {
    if (this.interval) {
      clearInterval(this.interval);
    }
    this.isRequest = true;
    this.fetchData();
    this.interval = setInterval(() => {
      this.fetchData();
    }, 10000);
  },
  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  },
  methods: {
    delayRequest() {
      if (this.delay) {
        clearTimeout(this.delay);
      }
      this.delay = setTimeout(() => {
        this.fetchData();
      }, 3000);
    },
    fetchData() {
      const client = new ActivityProxy();
      client[this.method](...this.args)
        .then((response) => {
          this.items = response.data.data.activity.data;
        })
        .catch((response) => {
          if (response && response.status === 401) {
            clearInterval(this.interval);
          }
          console.log(response);
        })
        .finally(() => {
          this.isRequest = false;
        });
    },
  },


};
</script>

<style scoped>

</style>
